<div class="p-4">
  <p class="mb-3">{{ "QUOTE.DRAWING.DIALOG.SEND_CONFIRM_BODY" | translate }}</p>

  <div class="flex justify-content-end gap-2 mt-4">
    <p-button [label]="'QUOTE.DRAWING.DIALOG.CANCEL' | translate" [text]="true" (onClick)="closeDialog()" />
    <p-button [label]="'QUOTE.DRAWING.DIALOG.CONFIRM' | translate" (onClick)="submit()" />
  </div>
</div>
